angular.module('acme.view.application.importExport.job.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.utils',
  'acme.common.directive.dataGrid',
  'acme.common.service.offline',
  'acme.common.service.permissions',
  'acme.view.application.importExport.importExportJob.directives.importExportJobMapping',
  'acme.view.application.importExport.importExportJob.directives.importExportJobMappings',
  'acme.view.application.importExport.importExportJob.directives.importExportJobMappings.importExportJobMappingsGrid',
  'acme.view.application.importExport.importExportJob.directives.importExportJobMappings.modals.change',
  'acme.view.application.importExport.importExportJob.directives.importExportJobMappings.modals.editor',
  'acme.view.application.importExport.exportJobExecution.controllers.exportJobExecutionController',
  'acme.view.application.importExport.exportJobExecution.controllers.exportJobExecutionOutputDownloadModalController',
]).controller('ImportExportJobController', ImportExportJobController);

/**
 * Controller responsible for loading a Import / Export Job
 * @class ImportExportJobController
 * @constructor
 * @param {Object} $rootScope - angular's $rootScope service
 * @param $timeout
 * @param $state
 * @param $uibModal
 * @param UtilsService
 * @param ImportJobsApiService
 * @param ImportJobExecutionsApiService
 * @param ImportExportsApiService
 * @param JOB_TYPE
 * @return {ImportExportJobController} - Class instance
 */
function ImportExportJobController(
  $rootScope,
  $timeout,
  $state,
  $uibModal,
  UtilsService,
  ImportJobsApiService,
  ImportJobExecutionsApiService,
  ImportExportsApiService,
  JOB_TYPE
) {
  Object.assign(this, {
    $rootScope: $rootScope,
    $timeout: $timeout,
    $state: $state,
    $uibModal: $uibModal,
    UtilsService: UtilsService,
    ImportJobsApiService: ImportJobsApiService,
    ImportJobExecutionsApiService: ImportJobExecutionsApiService,
    ImportExportsApiService: ImportExportsApiService,
    JOB_TYPE: JOB_TYPE
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

/**
 * Angular lifecycle method $onInit
 * @public
 * @memberOf ImportExportJobController
 * @return {Undefined} -
 */
ImportExportJobController.prototype.$onInit = function () {
  var self = this;

  self.jobId = this.$state.params.id;

  self.vm = {
    activeTab: 'executions',
    job: {},
    outputs: [],
    messages: []
  };

  this.ImportJobsApiService.get(self.jobId)
    .then(function (response) {
      self.vm.job = response.data;
      self._setupHeader();
      if (self.vm.job.jobType === self.JOB_TYPE.EXPORT) {
          self.ImportExportsApiService.getJobOutputs(self.jobId)
            .then(function (response) {
                self.vm.outputs = response.data;
            });
      }
    });
};

ImportExportJobController.prototype._setupHeader = function () {
  var self = this;
  var jobTypeTitle = self.vm.job.jobType === self.JOB_TYPE.EXPORT ? 'Export' : 'Import'; // TODO create lookup

  var titleChange = {
    title: jobTypeTitle + ' Job: ' + self.vm.job.name,
    buttonLeft: {
      label: 'Back',
      action: function () {
        self.$state.go('application.importExport.list');
      }
    }
  };

  self.$rootScope.$broadcast('Application::contentTitleChange', titleChange);
};

ImportExportJobController.prototype.createJobExecution = function (jobId) {
  var self = this,
    jobType = this.vm.job.jobType;

  if (jobType === self.JOB_TYPE.IMPORT) {
    self.ImportJobExecutionsApiService.create(jobId)
      .then(function (response) {
        self.$state.go('application.importExport.jobExecution', { id: response.data.id, jobId: jobId, tab: 'files' });
      });
  }
};

ImportExportJobController.prototype.executeExportJob = function (fromDate) {
  var self = this,
    date = this.UtilsService.getDateIfValid(fromDate);

  this.ImportExportsApiService.create(self.vm.job.id, date)
    .then(function (response) {
      self.$state.go('application.importExport.exportJobExecution', { id: response.data.id, jobId: self.vm.job.id });
    });
};

ImportExportJobController.prototype.showAddMapping = function () {
  var self = this;

  var modal = this.$uibModal.open({
    templateUrl: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/ImportExportJobMappingsModal.tpl.html',
    controller: 'ImportExportJobMappingsModalController',
    controllerAs: '$ctrl',
    resolve: {
      job: function () {
        return self.vm.job;
      },
      mode: function () {
        return 'add';
      },
      mappings: function () {
        return self.ImportJobsApiService.getMappings(self.jobId)
          .then(function (response) {
            return response.data;
          });
      },
      mapping: null
    }
  });

  modal.result.then(function (hasAdded) {
    if (hasAdded) {
      self.reloadMappings();
      self.showTemporarySuccessMessage('Successfully added a mapping');
    }
  });
};

ImportExportJobController.prototype.showMappingsEditorModal = function (mode, mapping) {
  var self = this;

  var modal = this.$uibModal.open({
    templateUrl: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/ImportExportJobMappingsEditorModal.tpl.html',
    controller: 'ImportExportJobMappingsEditorModalController',
    controllerAs: '$ctrl',
    resolve: {
      job: function () {
        return self.vm.job;
      },
      mappings: function () {
        return self.ImportJobsApiService.getMappings(self.jobId)
          .then(function (response) {
            return response.data;
          });
      }
    }
  });

  modal.result.then(function (hasAdded) {
    if (hasAdded) {
      self.reloadMappings();
      self.showTemporarySuccessMessage('Successfully updated mappings');
    }
  });
};

ImportExportJobController.prototype.reloadMappings = function () {
  this.$rootScope.$broadcast('ImportExport::mappingsRefresh');
};

ImportExportJobController.prototype.isActiveTab = function (tab) {
  return this.vm.activeTab === tab;
};

ImportExportJobController.prototype.setTab = function (tab) {
  this.vm.activeTab = tab;
};

ImportExportJobController.prototype.showTemporarySuccessMessage = function (message) {
  var self = this;
  self.vm.message = message;

  self.$timeout(function () {
    self.vm.message = '';
  }, 6000);
};

ImportExportJobController.$inject = [
  '$rootScope',
  '$timeout',
  '$state',
  '$uibModal',
  'UtilsService',
  'ImportJobsApiService',
  'ImportJobExecutionsApiService',
  'ImportExportsApiService',
  'JOB_TYPE'
];